/**
 * Auto-generated from dark-roast DAOs (com.axiom.db.models.dao).
 * Shared by all Java backends — do not edit manually.
 * Regenerate with: yarn sync-entities
 */

import { Entity } from '@data-client/rest';
import { AccountEntity } from './account-entity';
import { CandidateEntity } from './candidate-entity';
import { UserEntity } from './user-entity';
export class CandidatesAccountEntity extends Entity {
  account: AccountEntity | null = null;
  accountCandidateStatus: string | null = null;
  accountId: string | null = null;
  billingUnitsPerWeek: string | null = null;
  candidate: CandidateEntity | null = null;
  candidateId: string | null = null;
  createdAt: string | null = null;
  hasOtherEngagements: boolean | null = null;
  id: string = '';
  isHiddenExternal: boolean | null = null;
  isHiddenExternalUpdatedAt: string | null = null;
  isHiddenExternalUpdatedBy: string | null = null;
  isHiddenExternalUpdatedByUser: UserEntity | null = null;
  notes: string | null = null;
  notesUpdatedAt: string | null = null;
  notesUpdatedBy: string | null = null;
  notesUpdatedByUser: UserEntity | null = null;
  soonestAccountEngagementEndDate: string | null = null;
  updatedAt: string | null = null;
  weeklyTimeUnit: string | null = null;
  static override key = 'CandidatesAccount';
  static override get schema() {
    return {
      account: AccountEntity,
      candidate: CandidateEntity,
      isHiddenExternalUpdatedByUser: UserEntity,
      notesUpdatedByUser: UserEntity,
    };
  }
  static override toJSON() {
    return { name: this.name, schema: {}, key: this.key };
  }
  static override process(input: unknown): unknown {
    if (
      input !== null &&
      typeof input === 'object' &&
      'CandidatesAccount' in input
    ) {
      const { CandidatesAccount: wrapped, ...rest } = input as {
        CandidatesAccount: object;
      } & object;
      return { ...(wrapped as object), ...rest };
    }
    return input;
  }
}